import React, { useState } from 'react';
import HelpButton from '../Admin/HelpButton';
import BrandMarkSpinner from '../Loading/BrandMarkSpinner';

interface BulkSEOToolsProps {
  onBulkAction?: (action: string, data?: any) => void;
}

const BulkSEOTools: React.FC<BulkSEOToolsProps> = ({ onBulkAction }) => {
  const [isProcessing, setIsProcessing] = useState(false);

  const handleBulkAction = async (action: string) => {
    setIsProcessing(true);
    try {
      if (onBulkAction) {
        await onBulkAction(action);
      }
      // Simulate processing
      await new Promise(resolve => setTimeout(resolve, 1000));
    } finally {
      setIsProcessing(false);
    }
  };

  const bulkActions = [
    {
      id: 'generate-alt-text',
      icon: 'fas fa-image',
      title: 'Generate Alt Text',
      description: 'Auto-generate alt text for all images from filenames'
    },
    {
      id: 'generate-descriptions',
      icon: 'fas fa-file-alt',
      title: 'Generate Meta Descriptions',
      description: 'Create meta descriptions from content for all pages'
    },
    {
      id: 'optimize-images',
      icon: 'fas fa-compress',
      title: 'Optimize Images',
      description: 'Batch optimize images for social sharing (1200x630)'
    },
    {
      id: 'apply-template',
      icon: 'fas fa-layer-group',
      title: 'Apply SEO Template',
      description: 'Apply SEO template to multiple pages at once'
    },
    {
      id: 'fix-issues',
      icon: 'fas fa-wrench',
      title: 'Fix Common Issues',
      description: 'Automatically fix common SEO issues'
    },
    {
      id: 'validate-urls',
      icon: 'fas fa-link',
      title: 'Validate URLs',
      description: 'Check all canonical URLs for errors'
    }
  ];

  return (
    <div className="bulk-seo-tools">
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
        <h3>Bulk SEO Operations</h3>
        <HelpButton section="seo-content" tooltip="Bulk SEO Operations Help" />
      </div>
      <p style={{ color: '#6b7280', marginBottom: '1rem' }}>
        Perform bulk operations to optimize SEO across your entire website.
      </p>
      
      <div className="bulk-actions-grid">
        {bulkActions.map(action => (
          <div
            key={action.id}
            className="bulk-action-card"
            onClick={() => handleBulkAction(action.id)}
            style={{ opacity: isProcessing ? 0.6 : 1, cursor: isProcessing ? 'not-allowed' : 'pointer' }}
          >
            <div className="bulk-action-icon">
              <i className={action.icon}></i>
            </div>
            <div className="bulk-action-title">{action.title}</div>
            <div className="bulk-action-description">{action.description}</div>
          </div>
        ))}
      </div>

      {isProcessing && (
        <div style={{ textAlign: 'center', padding: '2rem', color: '#6b7280' }}>
          <BrandMarkSpinner size="medium" label="Processing bulk operation" caption />
        </div>
      )}
    </div>
  );
};

export default BulkSEOTools;

